module.exports = __webpack_public_path__ + "img/a0309_1.d83ad8b4.png";